"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimelineManager = void 0;
var moment = require("moment");
var milestone_1 = require("../models/milestone");
var timeline_1 = require("../models/milestone/timeline");
var profile_1 = require("../models/profile");
var milestone_2 = require("../schemas/milestone");
var timeline_find_1 = require("./timeline-find");
var TimelineManager = /** @class */ (function () {
    function TimelineManager() {
    }
    /**
     * Generates a full list of nodes with only minimal data
     */
    TimelineManager.generateNodesStateless = function (milestones, dog, dogSize) {
        if (dogSize === void 0) { dogSize = null; }
        var inputs = milestones.map(function (milestone) {
            var progress = milestone_1.MilestoneProgress.defaultProps(milestone, dog);
            return {
                instance: milestone,
                progress: progress
            };
        });
        return this.generateNodes(inputs, dog, dogSize);
    };
    /**
     * Generates a full list of nodes supplied by inputs
     */
    TimelineManager.generateNodes = function (inputs, dog, dogSize) {
        var _this = this;
        if (dogSize === void 0) { dogSize = null; }
        if (inputs.length < 1) {
            return [];
        }
        // Reset nodes
        var nodes = [];
        // Determine the min and max dates
        var _a = this.minMaxMilestones(inputs, dog), start = _a.start, end = _a.end;
        console.log('MinMax:', start.format('YYYY-MM-DD'), '-', end.format('YYYY-MM-DD'));
        // count up by month until we reach end
        var offset = 0;
        var range = end
            .endOf('month')
            .diff(start.startOf('months'), 'months');
        if (range < 0) {
            throw new Error('Cannot have a negative range, check if a min max was even set');
        }
        var present = start.startOf('month');
        var tick;
        // Build out nodes from range
        while (offset <= range) {
            tick = moment(present)
                .add(offset++, 'month');
            nodes.push({
                elements: [],
                updated: new Date().toISOString(),
                year: tick.year(),
                month: timeline_1.TimelineNode.month(tick.month())
            });
        }
        inputs.forEach(function (input) {
            _this.append(nodes, input, dog, dogSize);
        });
        // Assuming nodes are sorted by time
        return nodes;
    };
    /**
     * Adds or Replaces an element to a node
     */
    TimelineManager.append = function (nodes, input, dog, dogSize) {
        if (dogSize === void 0) { dogSize = null; }
        var updated = this.remove(nodes, input.progress.id);
        var assignments = [];
        // Handle recurring milestones
        if (input.instance.recurring) {
            console.log('Handling recurring', input.instance.name);
            // Get iterations up to a year in the future
            // @TODO performance, avoid doing calculations that are outside of the -1,1 time window
            var recurringInputs = [input];
            var unit = input.instance.timeline.unit;
            var min = moment.duration(input.instance.timeline.min, unit);
            var max = moment.duration(input.instance.timeline.max, unit);
            if (dogSize && input.instance.timeline.breedSizeOffets && input.instance.timeline.breedSizeOffets[dogSize]) {
                min.add(moment.duration(input.instance.timeline.breedSizeOffets[dogSize].value, input.instance.timeline.breedSizeOffets[dogSize].unit));
                max.add(moment.duration(input.instance.timeline.breedSizeOffets[dogSize].value, input.instance.timeline.breedSizeOffets[dogSize].unit));
            }
            // Look ahead at least 1 year in the future
            var limit = moment.duration(profile_1.Dog.ageFrom(dog.dob, 'years') + 3, 'years');
            var rate = moment.duration(input.instance.recurring.every, input.instance.recurring.unit);
            do {
                min.add(rate);
                max.add(rate);
                var instance = __assign(__assign({}, input.instance), { timeline: {
                        min: min.as(unit),
                        max: max.as(unit),
                        unit: unit
                    } });
                // @TODO handle recurring state, defaulting progress state at the moment...
                var progress = milestone_1.MilestoneProgress.defaultProps(instance, dog);
                recurringInputs.push({ progress: progress, instance: instance });
            } while (min.years() < limit.years() || max.years() < limit.years());
            for (var _i = 0, recurringInputs_1 = recurringInputs; _i < recurringInputs_1.length; _i++) {
                var recurringInput = recurringInputs_1[_i];
                assignments.push(this.nodeAssignment(updated, recurringInput, dog, dogSize));
            }
        }
        else {
            assignments.push(this.nodeAssignment(updated, input, dog, dogSize));
        }
        for (var _a = 0, assignments_1 = assignments; _a < assignments_1.length; _a++) {
            var assignment = assignments_1[_a];
            for (var _b = 0, _c = assignment.indexes; _b < _c.length; _b++) {
                var index = _c[_b];
                if (index > -1 && assignment.element) {
                    // Sometimes indexes can overlap (typically with recurring milestones),
                    // const index: number = this.elementExists(updated[index])
                    // @TODO merge conflicts - don't want to override available
                    var eIndex = this.elementExists(updated[index].elements, assignment.element);
                    if (eIndex > -1) {
                        updated[index].elements[eIndex] = assignment.element;
                    }
                    else {
                        updated[index].elements.push(assignment.element);
                    }
                    updated[index].elements.sort(function (a, b) {
                        var ad = moment.duration(a.instance.timeline.min, a.instance.timeline.unit);
                        var bd = moment.duration(b.instance.timeline.min, b.instance.timeline.unit);
                        if (dogSize && a.instance.timeline.breedSizeOffets && a.instance.timeline.breedSizeOffets[dogSize]) {
                            ad.add(moment.duration(a.instance.timeline.breedSizeOffets[dogSize].value, a.instance.timeline.breedSizeOffets[dogSize].unit));
                        }
                        if (dogSize && b.instance.timeline.breedSizeOffets && b.instance.timeline.breedSizeOffets[dogSize]) {
                            bd.add(moment.duration(b.instance.timeline.breedSizeOffets[dogSize].value, b.instance.timeline.breedSizeOffets[dogSize].unit));
                        }
                        return ad.asDays() - bd.asDays();
                    });
                }
                // else {
                //   console.error(`Could not append "${input.instance.name}", no index found`);
                // }
            }
        }
        return updated;
    };
    /**
     * Filters out any elements that have the same id provided
     */
    TimelineManager.remove = function (nodes, id) {
        return nodes.map(function (node) {
            node.elements = node.elements.filter(function (element) { return element.progress.id !== id; });
            return node;
        });
    };
    /**
     * 1. Assign Default State (cannot do locked, that comes from persistent data)
     * 2. Check if Complete: if complete, assign to node it was completed on
     * 3. Check if Expired: if expired, send to last node it belongs to.
     * 4. Check if Unavailable: if the Milestone has not started yet. Place it to the first Node it belongs to.
     *   -- Double Check: Check if unavailable but past current month, we should have this
     * 5. Check if Available: If the Milestone has started. Place it to the current Node.
     * 6. Check if Locked: same as Unavailable
     */
    TimelineManager.nodeAssignment = function (nodes, input, dog, dogBreedSize) {
        if (dogBreedSize === void 0) { dogBreedSize = null; }
        var _a = milestone_1.MilestoneProgress.absoluteTimeframe(input.instance, dog, dogBreedSize), start = _a.start, end = _a.end;
        var defaultState = milestone_1.MilestoneProgress.defaultState(input.instance, dog, start, end);
        var startIndex = -1;
        var endIndex = -1;
        switch (defaultState) {
            case milestone_2.MilestoneState.COMPLETE:
                if (input.progress.completed) {
                    var completed = new Date(input.progress.completed);
                    startIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(start.month.min), start.year.min);
                    endIndex = timeline_find_1.TimelineFind.findByTime(nodes, completed.getMonth(), completed.getFullYear());
                }
                else {
                    console.error("Milestone \"" + input.instance.name + "\" has no completed timestamp even though set to completed.");
                    startIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(start.month.min), start.year.min);
                    endIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(end.month.min), end.year.min);
                }
                break;
            case milestone_2.MilestoneState.LOCKED:
            case milestone_2.MilestoneState.UNAVAILABLE:
                if (defaultState === milestone_2.MilestoneState.UNAVAILABLE && this.isBetween(start, end)) {
                    console.error("Milestone \"" + input.instance.name + "\" was marked unavailable, but should be available");
                }
                startIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(start.month.min), start.year.min);
                // endIndex = TimelineFind.findByTime(nodes, TimelineNode.monthIndex(start.month.max), start.year.max);
                endIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(end.month.max), end.year.max);
                break;
            case milestone_2.MilestoneState.EXPIRED:
                startIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(end.month.min), end.year.min); // Not sure if needed
                endIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(end.month.max), end.year.max);
                break;
            case milestone_2.MilestoneState.AVAILABLE:
                if (!this.isBetween(start, end)) {
                    console.error("Milestone \"" + input.instance.name + "\" was marked available, but its start and end say otherwise");
                }
                else {
                    startIndex = timeline_find_1.TimelineFind.findToday(nodes);
                    endIndex = timeline_find_1.TimelineFind.findByTime(nodes, timeline_1.TimelineNode.monthIndex(end.month.max), end.year.max);
                }
                break;
            default:
                console.error("Milestone \"" + input.instance.name + "\" unknown state \"" + input.progress.state + "\"", 'Skipping this milestone.');
        }
        var validIndexes = true;
        var indexes = [];
        if (startIndex > -1 && endIndex > -1) {
            if (startIndex > endIndex) {
                console.error("Milestone \"" + input.instance.name + "\" Start is greater than end, " + startIndex + " > " + endIndex);
                indexes.push(endIndex);
            }
            else {
                indexes.push.apply(indexes, this.range(startIndex, endIndex));
            }
        }
        else if (startIndex > -1) {
            indexes.push(startIndex);
        }
        else if (endIndex > -1) {
            indexes.push(endIndex);
        }
        for (var _i = 0, indexes_1 = indexes; _i < indexes_1.length; _i++) {
            var i = indexes_1[_i];
            if (!nodes[i]) {
                validIndexes = false;
            }
        }
        if (validIndexes) {
            return {
                indexes: indexes,
                element: {
                    progress: input.progress,
                    instance: input.instance,
                    icon: timeline_1.TimelineElement.getIcon(input.instance.category),
                    updated: new Date().toISOString()
                }
            };
        }
        else {
            console.error('Invalid indexes', indexes);
            console.error("Could not add \"" + input.instance.name + "\" since it does not exist, (start, end)", start, end);
            return {
                indexes: [],
                element: null
            };
        }
    };
    TimelineManager.minMaxMilestones = function (inputs, dog) {
        // view from 1 year in the future and 1 in the past
        var data = {
            start: moment().set('year', new Date().getFullYear() - 1),
            end: moment().set('year', new Date().getFullYear() + 1) // at least look one year out
        };
        return data;
    };
    TimelineManager.isBetween = function (start, end) {
        var compareDate = new Date().setHours(0, 0, 0, 0);
        var startDate = new Date(start.date.min).setHours(0, 0, 0, 0);
        var endDate = new Date(end.date.max).setHours(0, 0, 0, 0);
        return compareDate <= endDate && compareDate >= startDate;
    };
    TimelineManager.range = function (start, stop, stepSize) {
        if (stop === void 0) { stop = null; }
        if (stepSize === void 0) { stepSize = 1; }
        if (stop === null) {
            stop = start;
            start = 1;
        }
        var steps = (stop - start) / stepSize;
        var set = [];
        for (var step = 0; step <= steps; step++) {
            set.push(start + step * stepSize);
        }
        return set;
    };
    TimelineManager.elementExists = function (elements, ref) {
        return elements.findIndex(function (e) { return e.instance.id === ref.instance.id; });
    };
    return TimelineManager;
}());
exports.TimelineManager = TimelineManager;
